var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSparkles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3009_13107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.53345 5.86948L7.10292 1.62807L8.67238 5.86948C8.78621 6.1771 9.02874 6.41963 9.33635 6.53345L13.5778 8.10292L9.33635 9.67238C9.02874 9.78621 8.78621 10.0287 8.67238 10.3364L7.10292 14.5778L5.53345 10.3364C5.41963 10.0287 5.17709 9.78621 4.86948 9.67238L0.62807 8.10292L4.86948 6.53345C5.1771 6.41963 5.41963 6.17709 5.53345 5.86948Z",
    stroke: "#008080",
    strokeWidth: 1.13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9417 13.277L13.5301 11.6869L14.1185 13.277C14.2324 13.5847 14.4749 13.8272 14.7825 13.941L16.3727 14.5294L14.7825 15.1178C14.4749 15.2316 14.2324 15.4742 14.1185 15.7818L13.5301 17.3719L12.9417 15.7818C12.8279 15.4742 12.5854 15.2316 12.2778 15.1178L10.6876 14.5294L12.2778 13.941C12.5854 13.8272 12.8279 13.5847 12.9417 13.277Z",
    stroke: "#008080",
    strokeWidth: 1.13
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3009_13107"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkles);
export default __webpack_public_path__ + "static/media/sparkles.82152933efcdd8644d958ddcaf03fa50.svg";
export { ForwardRef as ReactComponent };